import React from "react";
import styles from "./Cart.module.css";
import { CartItemPlaceholderProps } from "@model/Cart.model";



const CartItemPlaceholder: React.FC<CartItemPlaceholderProps> = ({ index }) => {
  return (
    <div className={styles.PlaceholderItem} data-testid={`cart-item-${index}`}>
      <div
        className={`${styles.PlaceholderThumb} ${styles.PlaceholderSkeleton}`}
        data-testid={`cart-item-${index}-thumb`}
      />
      <div className={styles.PlaceholderInfo}>
        <div
          className={`${styles.PlaceholderLine} ${styles.PlaceholderSkeleton}`}
          data-testid={`cart-item-${index}-line`}
        />
        <div
          className={`${styles.PlaceholderLineShort} ${styles.PlaceholderSkeleton}`}
          data-testid={`cart-item-${index}-line-short`}
        />
      </div>
      <div className={styles.PlaceholderActions}>
        <div
          className={`${styles.PlaceholderBtn} ${styles.PlaceholderSkeleton}`}
          data-testid={`cart-item-${index}-btn-1`}
        />
        <div
          className={`${styles.PlaceholderBtn} ${styles.PlaceholderSkeleton}`}
          data-testid={`cart-item-${index}-btn-2`}
        />
      </div>
    </div>
  );
};

export default CartItemPlaceholder;
